export default __webpack_public_path__ + "static/media/day14.6d4ba511.png";